import { union } from 'lodash-es'

import { EMPTY_LIST } from '../../../../../constants/common'
import { TOGGLE_FILTER_TYPE } from '../../../../../constants/filter'

import {
  APPLICANTS_FILTER_PARAM_LIST,
  APPLICANTS_FILTER_TOGGLE_VALUE,
} from './useRentalPortalApplicantsFilters.constants'

function getApplicantsFilterParamList(filter) {
  return [filter.query_param].flat()
}

function getApplicantsFilterByParam(availableFilters) {
  return Object.fromEntries(
    (availableFilters ?? EMPTY_LIST).flatMap(filter =>
      getApplicantsFilterParamList(filter).map(param => [param, filter])
    )
  )
}

function getApplicantsAppliedFilterValue({ filter, value }) {
  if (filter.type === TOGGLE_FILTER_TYPE) {
    return value === APPLICANTS_FILTER_TOGGLE_VALUE ? value : null
  }

  return filter.options
    ? (filter.options.find(option => String(option.value) === value)?.value ??
        null)
    : value
}

export function getApplicantsClearedFilterParamList(availableFilters) {
  return union(
    APPLICANTS_FILTER_PARAM_LIST,
    (availableFilters ?? EMPTY_LIST).flatMap(getApplicantsFilterParamList)
  )
}

export function getApplicantsFilterValues({ availableFilters, searchParams }) {
  const filterByParam = getApplicantsFilterByParam(availableFilters)

  return Object.fromEntries(
    Object.entries(filterByParam)
      .filter(([param]) => searchParams.has(param))
      .map(([param, filter]) => [
        param,
        getApplicantsAppliedFilterValue({
          filter,
          value: searchParams.get(param),
        }),
      ])
      .filter(([, value]) => value !== null)
  )
}

export function getApplicantsFilterParams(filterValues) {
  return Object.entries(filterValues).flatMap(([param, value]) =>
    [value]
      .flat()
      .filter(Boolean)
      .map(entry => [param, entry])
  )
}
